import Loader from 'Molecules/Loader/Loader';
import TaskBundlePageContent from './components/TaskBundlePageContent';

import { SLICE_STATUS } from 'utils/constants';
import { useTaskBundlePage } from './hooks/useTaskBundlePage';
import { TaskBundleProvider } from './providers/TaskBundleProvider/TaskBundleProvider';

const TaskBundlePage = () => {
  const { status, mode, initialDraft, activeTab, onTabChange } =
    useTaskBundlePage();

  if (status === SLICE_STATUS.LOADING) {
    return <Loader />;
  }

  return (
    <TaskBundleProvider mode={mode} initialDraft={initialDraft}>
      <TaskBundlePageContent
        activeTab={activeTab}
        onTabChange={onTabChange}
        mode={mode}
      />
    </TaskBundleProvider>
  );
};

export default TaskBundlePage;
